/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxcPortfolioV1BalanceSnapshotState } from '@interxfi/types';
import { schema } from 'normalizr';

export const IXC_PORTFOLIO_V1_BALANCE_SNAPSHOT_STATE_ENTITY_NAME = 'ixc.portfolio.v1.BalanceSnapshot';
export const ixcPortfolioV1BalanceSnapshotStateEntity = new schema.Entity<IxcPortfolioV1BalanceSnapshotState>(IXC_PORTFOLIO_V1_BALANCE_SNAPSHOT_STATE_ENTITY_NAME, {}, { idAttribute: (entity: IxcPortfolioV1BalanceSnapshotState) => `${entity.accountId}-${entity.snapshotId}-${entity.assetId}` });

